import { errorNotify } from "@/plugins/functions";

const ROUTE = 'business/teacher_groups';

export function getGroups() {
  this.$loading(true);
  this.$http
    .get(`${ROUTE}`, {
      params: {},
    })
    .then((response) => {
      this.groups = response.data.data;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function getClients(group_id = null) {
  this.$loading(true);
  this.$http
    .get(`${ROUTE}/${group_id}/clients`)
    .then((response) => {
      this.clients = response.data.data;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function setHere(id = null, client) {
  this.$loading(true);
  this.$http
    .post(`business/timetables/${id}/clients`,
      {
        client: client
      },
    )
    .then((response) => {
      // console.log(response);
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function setHereAll(id = null) {

  this.$dialog
    .confirm("Вы точно хотите установить? Отсутствующих уже не восстановить", {
      okText: "Продолжить",
      cancelText: "Отмена",
    })
    .then(() => {
      this.$loading(true);
      this.$http
        .post(`business/timetables/${id}/clients`, { all: true })
        .then((response) => {
          for (let i = 0; i < this.clients.length; i++) {
            this.clients[i]['status'] = 0;
          }
          return response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    })
    .catch(() => { });



}

export function setReport(client_id, discipline_id, description) {
  this.$loading(true);
  this.$http
    .post(`business/clients/${client_id}/disciplines/${discipline_id}/reports`,
      {
        description
      },
    )
    .then((response) => {
      this.$modal.hide('report');
      this.$notify({
        title: "Жалоба отправлена",
        message: "Сообщение отправлено родителям",
        icon: "ti-save",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function setRating(item = {}, type = 'post') {

  this.$loading(true);

  return this.$http
    ({
      url: `business/ratings${type === 'delete' ? `/${item.id}` : ``} `,
      method: type,
      data: item
    })
    .then((response) => {

      let data = response.data.data;
      if (data) {
        if (data.isCreated === true) {
          this.value.push(data);
          this.$emit('input', this.value);
        }
        else if (data.isCreated === false) {
          let exists = false;
          for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].id == data.id) {
              exists = true;
              this.value[i] = data;
            }
          }
          if (exists === false) {
            this.value.push(data);
          }
          this.$emit('input', this.value);
        }
      }

      if (type === 'delete') {
        // console.log(item);
        for (let i = 0; i < this.value.length; i++) {
          if (this.value[i].id == item.id) {
            this.value.splice(i, 1);
          }
        }
        this.$emit('input', this.value);
      }


      this.$modal.hide(`rating-${item.client.id}`);
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      this.$store.dispatch("setLastUpdate", new Date());
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function getJournal(group_id = null) {
  this.$loading(true);
  this.$http
    .get(`${ROUTE}/${group_id}/journals`)
    .then((response) => {
      this.journals = response.data.data;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function getRating(client_id = null, lessonplan_id) {
  this.$loading(true);
  this.$http
    .get(`${ROUTE}journal/rating`, {
      params: {
        client_id: client_id,
        lessonplan_id: lessonplan_id,
      },
    })
    .then((response) => {
      return this.response;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function getMessages(chat_id = null, limit = 30, offset = 0) {
  this.$loading(true);
  this.$http
    .get(`business/chats/${chat_id}`)
    .then((response) => {
      if (response.data && response.data.data) {
        this.messages = response.data.data.slice().reverse();
      }
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
      this.scrollBottom(10);
    });
}

export function sendMessage(chat_id = null, text = 30, media = []) {

  this.messages.push({
    created_at: new Date(),
    text: text,
    from: 'me',
    media: []
  });

  this.$http
    .post(`business/chats`, {
      chat_id: chat_id,
      text: text,
      media: media
    })
    .then((response) => {
      if (response.data) {
        //   this.messages.push(response.data);
      }
      this.text = '';
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      this.scrollBottom(10);
    });
}


export function getGroupMessages(group_id = null, limit = 30, offset = 0) {

  this.$loading(true);
  this.$http
    .get(`business/group_chats/${group_id}`)
    .then((response) => {
      if (response.data && response.data.data) {
        this.messages = response.data.data.slice().reverse();
      }
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
      this.scrollBottom(10);
    });
}

export async function sendGroupMessage(group_id = null, text = '', media = null) {


  try {
    await this.messages.push({
      id: new Date(),
      created_at: new Date(),
      message: text,
      media: [],
      chat: this.$store.state.user.chat,
      chat_id: this.$store.state.user.chat.id
    });

    this.$http
      .post(`business/group_chats/${group_id}`, {
        message: text,
        file: media
      })
      .then((response) => {
        if (response.data) {
          // this.messages.push(response.data.data);
        }
        this.text = '';
      })
      .catch((error) => {
        errorNotify(error, this.$notify);
      })
      .finally(() => {
        this.scrollBottom(10);
      });
  } catch (error) {
    alert('Сообщение не отправлено');
  }


}
